// @flow
import React from 'react';
import {
  AutoSizer, Grid,
} from 'react-virtualized';

import {
  scrollbarSize,
} from 'chronos-utils';


function calculateHeight(props, ASheight) {
  const { subtractHorizontalScrollbar, height } = props;
  let realHeight = height || ASheight;
  realHeight -= subtractHorizontalScrollbar ? scrollbarSize : 0;
  return realHeight;
}

function calculateWidth(props, ASwidth) {
  const { subtractVerticalScrollbar, width } = props;
  let realWidth = width || ASwidth;
  realWidth -= subtractVerticalScrollbar ? scrollbarSize : 0;
  return realWidth;
}

type GridProps = {
  minGrid: number,
  rowCount: number,
  rowHeight: number,
  columnCount: number,
  columnWidth: number,
  style: Object,
  containerStyle: Object,
};

type WrapperProps = {
  width: number,
  height: number,
  gridProps: GridProps,
};

const GridWrapper = ({ width, height, gridProps }: WrapperProps) => {
  const { columnCount, rowCount, columnWidth, rowHeight, minGrid } = gridProps;
  const style = gridProps.style || {};
  let minColumnCount = 0;
  let minRowCount = 0;
  if (minGrid) {
    minColumnCount = Math.floor(width / columnWidth);
    minRowCount = Math.ceil(height / rowHeight);
    style.overflowX = 'scroll';
  }

  if (minRowCount > rowCount) {
    style.overflowY = 'hidden';
  }

  return (
    <div
      style={{
        height: gridProps.height || height,
        width: gridProps.width || width,
      }}
    >
      <Grid
        {...gridProps}
        height={calculateHeight(gridProps, height)}
        width={calculateWidth(gridProps, width)}
        rowCount={minGrid ? Math.max(minRowCount, rowCount) : rowCount}
        columnCount={
          minGrid ? Math.max(minColumnCount, columnCount) : columnCount
        }
        style={style}
        containerStyle={{ overflow: 'visible' }}
      />
    </div>
  );
};

type Props = GridProps;

const VirtualGrid = (props: Props) => (
  <AutoSizer>
    {({ height, width }) => (
      <GridWrapper height={height} width={width} gridProps={props} />
    )}
  </AutoSizer>
);

VirtualGrid.defaultProps = {
  extraHeight: 0,
};

export default VirtualGrid;
